import React from 'react';
import styled from 'styled-components';
import Header from './Header';
import MatrixBackground from './MatrixBackground';
import theme from '../theme';

const LayoutContainer = styled.div`
  min-height: 100vh;
  background: ${theme.colors.bg};
  color: ${theme.colors.text};
  position: relative;
`;

const Main = styled.main`
  position: relative;
  z-index: 1;
  min-height: calc(100vh - 80px);
`;

const Layout = ({ children }) => {
  return (
    <LayoutContainer>
      <MatrixBackground />
      <Header />
      <Main>{children}</Main>
    </LayoutContainer>
  );
};

export default Layout;